import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const ProductivityTrendsChart = ({ data }) => {
  return (
    <div className="card">
      <h3 className="text-xl font-heading font-semibold text-foreground mb-6">
        Productivity Trends by Role
      </h3>
      <div className="w-full h-80" aria-label="Productivity Trends Line Chart">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="week" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '14px' }}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '14px' }}
              domain={[0, 100]}
            />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'var(--color-card)',
                border: '1px solid var(--color-border)',
                borderRadius: '12px',
                padding: '12px'
              }}
              formatter={(value) => `${value}%`}
            />
            <Legend 
              wrapperStyle={{ paddingTop: '20px' }}
              iconType="circle"
            />
            <Line 
              type="monotone" 
              dataKey="frontDesk" 
              stroke="var(--color-primary)" 
              strokeWidth={3}
              dot={{ fill: 'var(--color-primary)', r: 5 }}
              activeDot={{ r: 7 }}
              name="Front Desk"
            />
            <Line 
              type="monotone" 
              dataKey="trainers" 
              stroke="var(--color-success)" 
              strokeWidth={3}
              dot={{ fill: 'var(--color-success)', r: 5 }}
              activeDot={{ r: 7 }}
              name="Trainers"
            />
            <Line 
              type="monotone" 
              dataKey="maintenance" 
              stroke="var(--color-warning)" 
              strokeWidth={3}
              dot={{ fill: 'var(--color-warning)', r: 5 }}
              activeDot={{ r: 7 }}
              name="Maintenance"
            />
            <Line 
              type="monotone" 
              dataKey="management" 
              stroke="var(--color-accent)" 
              strokeWidth={3}
              dot={{ fill: 'var(--color-accent)', r: 5 }}
              activeDot={{ r: 7 }}
              name="Management"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ProductivityTrendsChart;